import React from 'react';
import styled from 'styled-components';
import Colors from '../../../../ui/global/Colors';
import Fonts from '../../../../ui/global/Fonts';
import Icon from '../../../../ui/global/Icon';

const Card = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-radius: 4px;
    background-color: ${Colors.grey9};
    border: 1px solid ${Colors.grey8};
    font-size: 14px;
    line-height: 1.2em;
    padding: 5px;
    gap: 6px;
    user-select: none;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background-color: ${Colors.grey8};
        border: 1px solid ${Colors.grey7};
    }

    &:active {
        background-color: ${Colors.grey7};
    }
`;

const IconContainer = styled.div<{ backgroundColor?: string }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    aspect-ratio: 1 / 1;
    max-width: 100%;
    background-color: ${props => props.backgroundColor || 'transparent'};
    border-radius: 4px;
    transition: all 0.2s ease;
`;

const Name = styled.h4`
    width: 100%;
    font-family: ${Fonts.lexendSemiLight.fontFamily};
    font-weight: ${Fonts.lexendSemiLight.fontWeight};
    color: ${Colors.white};
    text-align: center;
    padding: 2px 2px 6px 2px;
    margin: 0 auto;
`;

interface ActionCardProps {
    name: string;
    icon: string;
    backgroundColor?: string;
    iconColor?: string;
    onClick: () => void;
    disabled?: boolean;
    iconSize?: number;
}

const ActionCard: React.FC<ActionCardProps> = ({
    name,
    icon,
    backgroundColor,
    iconColor = Colors.black,
    onClick,
    disabled = false,
    iconSize = 48
}) => {
    return (
        <Card
            onClick={disabled ? undefined : onClick}
            style={{
                opacity: disabled ? 0.4 : 1,
                cursor: disabled ? 'default' : 'pointer'
            }}
        >
            <IconContainer backgroundColor={backgroundColor}>
                <Icon icon={icon} size={iconSize} color={iconColor} />
            </IconContainer>
            <Name>{name}</Name>
        </Card>
    );
};

export default ActionCard;